import { Product } from 'src/api';

/** Stripe add_on metadata key (same as Flask billing / enabled_features). */
export const INTEGRATION_ADDON_FEATURES_METADATA_KEY = 'features';

/** Connector RID from Stripe add_on metadata (e.g. `connector.advoware.de`). */
export function integrationAddOnFeatureFromProduct(product: Product): string | undefined {
  const features = product.metadata?.[INTEGRATION_ADDON_FEATURES_METADATA_KEY];
  if (typeof features !== 'string') {
    return undefined;
  }
  const trimmed = features.trim().toLowerCase();
  return trimmed || undefined;
}

/** `connector.advoware.de` → `advoware` (asset / logo keys only). */
export function connectorAddonSlugFromRid(connectorRid: string): string {
  const normalized = connectorRid.trim().toLowerCase();
  const match = /^connector\.([^.]+)(?:\.|$)/.exec(normalized);
  return match?.[1] ?? normalized;
}

export function buildIntegrationAddOnsByRid(products: readonly Product[]): Map<string, Product> {
  const map = new Map<string, Product>();
  for (const product of products) {
    const rid = integrationAddOnFeatureFromProduct(product);
    if (rid) {
      map.set(rid, product);
    }
  }
  return map;
}

export function findIntegrationAddOnForConnectorRid(
  addOnsByRid: ReadonlyMap<string, Product>,
  connectorRid: string | undefined | null,
): Product | null {
  if (!connectorRid) {
    return null;
  }
  return addOnsByRid.get(connectorRid.trim().toLowerCase()) ?? null;
}
